import { ENVIRONMENTS, getEnvFromHostname } from '../../pages/utils/getEnvFromHostname';

export const getSettingsLink = (): string => {
  const env = getEnvFromHostname();
  const systemCustomerID = window.merchantos.session.getSystemCustomerID() as string;
  let analyticsHostURL = 'http://cranklogic.localdev';
  const reportingLink =
    '/reports/redirect/ddd476e3-a25b-4013-90fd-a4765cc4af5c?ct=ConfigureDynamicReordering&ls_account_id=';
  switch (env) {
    case ENVIRONMENTS.PRODUCTION:
      analyticsHostURL = 'https://lightspeedanalytics.net';
      break;
    case ENVIRONMENTS.STAGING:
      analyticsHostURL = 'https://staging.lightspeedanalytics.net';
      break;
    default:
  }
  return `${analyticsHostURL}${reportingLink}${systemCustomerID}`;
};
